import { useParams } from 'react-router-dom'
import EditTaskForm from './EditTaskForm'

import { useGetTasksQuery } from './tasksApiSlice'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
const EditTask = () => {
    useTitle('geshtop-Exercise: Edit Task')

    const { taskId } = useParams()

    const { username, isTeacher, isAdmin } = useAuth()

    const { task } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            task: data?.entities[taskId]
        }),
    })

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!task || !groups) return <PulseLoader color={"#FFF"} />

    // if (!isTeacher && !isAdmin) {
    //     if (task.username !== username) {
    //         return <p className="errmsg">No access</p>
    //     }
    // }

    const content =
    <>
    <EditTaskForm task={task} groups={groups} />  
       
    </>

    return content
}
export default EditTask